import {
  forwardRef,
  MenuItem as ChakraMenuItem,
  MenuItemProps as ChakraMenuItemProps,
  useMenuStyles,
  SystemStyleObject,
} from '@chakra-ui/react';
import { TypeColors } from '../../types/bitkit';
import Box from '../Box/Box';
import Icon, { TypeIconName } from '../Icon/Icon';

const dangerStyle = {
  _active: {
    background: 'red.90',
  },
  _focus: {
    background: 'red.93',
    boxShadow: 'none',
  },
  color: 'red.50',
};

export interface MenuItemProps extends Omit<ChakraMenuItemProps, 'icon'> {
  as?: 'a' | 'button';
  iconName?: TypeIconName;
  isDanger?: boolean;
  leftIconColor?: TypeColors;
  leftIconName?: TypeIconName;
  rightIconColor?: TypeColors;
  rightIconName?: TypeIconName;
}

const MenuItem = forwardRef<MenuItemProps, 'button'>((props, ref) => {
  const styles = useMenuStyles();

  const { size: iconSize, ...restIconStyles } = styles.icon as SystemStyleObject & { size: '16' | '24' };

  const {
    as,
    children,
    iconName,
    isDanger,
    isDisabled,
    leftIconColor,
    leftIconName,
    rightIconColor,
    rightIconName,
    ...rest
  } = props;
  const properties: ChakraMenuItemProps = {
    as: isDisabled ? 'button' : as,
    iconSpacing: '12',
    isDisabled,
    ...rest,
  };

  if (iconName || leftIconName || rightIconName) {
    properties.children = (
      <Box alignItems="center" display="flex" gap={properties.iconSpacing} width="100%">
        {(iconName || leftIconName) && (
          <Icon
            color={leftIconColor}
            name={iconName || leftIconName || 'Bitbot'}
            size={iconSize}
            __css={restIconStyles}
          />
        )}
        {children}
        {rightIconName && (
          <Icon
            color={rightIconColor}
            marginInlineStart="auto"
            name={rightIconName}
            size={iconSize}
            __css={restIconStyles}
          />
        )}
      </Box>
    );
  } else {
    properties.children = children;
  }
  // There is no variant for MenuItem
  if (isDanger) {
    properties.sx = dangerStyle;
  }
  return <ChakraMenuItem {...properties} ref={ref} />;
});

export default MenuItem;
